/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_LengthInputs */



/**
* | output |
* | --- |
* | "Program Length" |
*
* @param {Subtitle_Export_Program_LengthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_length = /** @type {((inputs?: Subtitle_Export_Program_LengthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_LengthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée du programme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programmlänge")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata del programma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Длительность программы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración del programa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("节目时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムの長さ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम की अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração do programa")
	return /** @type {LocalizedString} */ ("Program Length")
});